export default async function uploadFileToDrupal(file, entityType, bundle, fieldName) {
    const uploadUrl = `${process.env.CLF_BACKEND_URL}/file/upload/${entityType}/${bundle}/${fieldName}?_format=json`;
    const formData = new FormData();
    formData.append('file', file);
  
    try {
      const response = await fetch(uploadUrl, {
        method: "POST",
        body: formData,
      });
  
      if (response.ok) {
        const fileData = await response.json();
        return fileData;
      } else {
        throw new Error('File upload failed');
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      return null;
    }
}
  